import { useUsers } from "@/helpers/hooks";
import { Privacy } from "@/helpers/constants";
import { PrivacyAware } from "@/types";
import { useAppState } from "@/modules/app/useAppContext";

/**
 * Hook to check if the current user can edit privacy-aware items
 *
 * Privacy permission rules:
 * - Private items can always be edited by anyone with access
 * - Public items can only be edited by the owner
 *
 * @returns Function to check edit permissions for privacy-aware items
 */
export function useCanEditPrivacyAware() {
  const { getById: getUserById } = useUsers();
  const { loggedinUser } = useAppState();

  const canEdit = (item: PrivacyAware | null | undefined): boolean => {
    if (!loggedinUser || !item) return false;

    // Private items can always be edited by anyone with access
    if (item.privacy === Privacy.PRIVATE) return true;

    // Public items can only be edited by the owner
    if (item.privacy === Privacy.PUBLIC && item.user_id) {
      const creator = getUserById(item.user_id);
      return creator?.uuid === loggedinUser.uuid;
    }

    return false;
  };

  return canEdit;
}
